import { isBrowser } from '../../utils/gatsbyUtils';

export const getStickyStyle = (isSticky: boolean) => {
  if (isBrowser()) {
    const elHeader = document && document.querySelector('#header');
    if (elHeader) {
      return isSticky
        ? {
            top:
              elHeader.getClientRects()[0].height +
              elHeader.getClientRects()[0].top,
            transform: 'translateY(-4px)',
            width: '100%',
            left: '0',
            right: '0',
            zIndex: 3,
          }
        : {};
    }
  }
  return {};
};
